import { render, staticRenderFns } from "./InputTextareaCpt.vue?vue&type=template&id=4a9ecec8&scoped=true&"
import script from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"
export * from "./InputTextareaCpt.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextareaCpt.vue?vue&type=style&index=0&id=4a9ecec8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ecec8",
  null
  
)

export default component.exports